import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Contexto } from '../../models/contexto';

import { ArbolMenu } from '../asistencia-menu-arbol/models/arbol-menu';
import { NodeType } from '../asistencia-menu-arbol/models/node-type';
import { NodoArbolMenu } from '../asistencia-menu-arbol/models/nodo-arbol-menu';
import { ArbolMenuHistorico } from '../asistencia-menu-arbol/models/arbol-menu-historico';
import { MenuArbolService } from '../asistencia-menu-arbol/services/menu-arbol.service';
import { environment } from 'src/environments/environment';
import { ConciergeService } from '../../services/concierge.service';

import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/asistente-en-linea/services/local-storage.service';

@Component({
  selector: 'app-asistencia-tramite',
  templateUrl: './asistencia-tramite.component.html',
  styleUrls: ['./asistencia-tramite.component.scss']
})
export class AsistenciaTramiteComponent {
 
  @Input() public ctx: Contexto;
  
  @Output() renderMenuArbolEmitter = new EventEmitter<Object>();
  @Output() nodeEmitter: EventEmitter<string>;
  @Output() displayAnswerEmitter: EventEmitter<NodoArbolMenu>;

  cargandoDatos: boolean;
  arbolMenu: ArbolMenu;
  arbolMenuHistorico: ArbolMenuHistorico[];
  menusNodos: string[];
  currentFAQ: NodoArbolMenu[];
  faq: any;
  currentFather: NodoArbolMenu; //o currentRoute (la ruta hasta el nodo padre)
  currentFatherSinceNode: NodoArbolMenu;
  currentArbol: ArbolMenuHistorico;
  currentFatherOldMenu: NodoArbolMenu;
  displayCurrentFatherOldMenu: boolean;
  displayButtonReturnNode: boolean;
  temaCurrentFatherOldMenu: string;
  currentGrandparent: NodoArbolMenu;
  currentFatherNode: NodoArbolMenu;
  displayedNodes: NodoArbolMenu[]; //Los nodos que se mostrarán en en menú en el estado actual del programa.
  answerDisplayed: boolean;
  answerNode: NodoArbolMenu;
  temaActual: string;

  testVarToDisplayUrls: any;
  visiblePath: string;
  maxPathLength: number = 100;
  subscriptionConcierge: Subscription;
  displayFormEmpresa: boolean;
  displayForm: boolean;
  habilitado: boolean;
  cantidadNodos: number;
  numberOfSiblingsArr: number[];
  numberOfSiblingsArrCreation: number[];

  mostrarDiv = true;
  miValorVariable: string = 'Raiz';
  miValorVariablePadre: string = '';


  constructor(private localstorage: LocalStorageService,
    public conciergeService: ConciergeService,
    private menuArbolService: MenuArbolService) {
    this.answerDisplayed = false;
    this.displayFormEmpresa = false;
    this.displayCurrentFatherOldMenu = false;
    this.displayButtonReturnNode = false;
    this.displayForm = true;
    this.temaActual = "Declaración Nominada"
    this.arbolMenuHistorico = [];
    this.menusNodos = [];
    this.temaCurrentFatherOldMenu = '';
    this.nodeEmitter = new EventEmitter<string>();
    this.displayAnswerEmitter = new EventEmitter<NodoArbolMenu>()
    this.renderMenuArbolEmitter = new EventEmitter<Object>();
  }


  ngOnInit() {
    //this.loadArbolMenu(this.ctx.idMenu, this.ctx.idNodo);
    console.log("this.ctx.idNodo",this.ctx.idMenu,this.ctx.idNodo,this.currentFather);
  }

  loadArbolMenu(idMenu, idNodo) {
    this.cargandoDatos = true;
    this.answerDisplayed = true;
    this.menuArbolService.loadMenuArbolTree(idMenu, idNodo).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let jsonTree = data.content;
        this.habilitado = jsonTree.habilitado;
        let root = new NodoArbolMenu("ROOT", data.content.idMenu, "Raiz",undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0, jsonTree.faqs, undefined, data.content.descripcionMenu)
        let arbol = new ArbolMenu(root);
        this.arbolMenu = arbol.buildTree(jsonTree)

        if (!this.arbolMenuHistorico.some(item => item.idMenu === idMenu)) {
          this.currentArbol = new ArbolMenuHistorico(this.arbolMenu, idMenu, this.arbolMenu.root, this.currentFatherOldMenu);
          if (!this.arbolMenuHistorico.includes(this.currentArbol)) {
            this.arbolMenuHistorico.push(this.currentArbol);
          }
        }

        this.currentFather = this.arbolMenu.root;
        this.currentGrandparent = undefined;
        if (this.ctx.idNodo && this.currentFatherSinceNode == undefined) {
          this.currentFatherSinceNode = this.arbolMenu.search(this.ctx.idNodo);
          if (this.currentFatherSinceNode) {
            this.displayButtonReturnNode = false;
            this.currentFather = this.currentFatherSinceNode;
            this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
            switch (this.currentFather.type) {
              case NodeType.Tramite: {
               // this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.currentFather, tipo:NodeType.Tramite })
                this.answerNode = this.currentFatherSinceNode;
                this.answerDisplayed = false;
                this.cargandoDatos=false;
                this.currentFather = this.currentGrandparent;
                this.habilitado = true;
                break;
              }
            }
          }
        }
        if (!this.menusNodos.includes(this.ctx.idMenu)) {
          this.menusNodos.push(this.ctx.idMenu);
        }

        //if(!cargarDesdeNodo) {
        this.reloadTree();
        this.faq = jsonTree.menuFAQ;
        this.loadFAQ();
        //}



        this.updateVisiblePath();
        this.miValorVariable = this.currentFather.name !== "Raiz" ? this.currentFather.name : 'Raiz';
        this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
        // Si tiene definido empresa verifica que venga instanciada. Si no viene no muestra el formulario
        if (this.ctx.formElements.datosEmpresa) {
          this.displayFormEmpresa = (this.ctx.datosEmpresa.nroEmpresa !== undefined);
        } else {
          this.displayFormEmpresa = true;
        }
        this.cargandoDatos = false;
      } else {
        // alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        //alert(error);
        this.cargandoDatos = false;
      })
  }

  async irToStartNode() {
    this.currentFatherNode = undefined;
    this.currentFatherOldMenu = undefined;
    this.temaCurrentFatherOldMenu = undefined;
    this.displayCurrentFatherOldMenu = false;
    this.ctx.idMenu = this.ctx.historialMenus[0];
    this.ctx.historialMenus = [this.ctx.idMenu];
    this.menusNodos = [this.ctx.idMenu];
    this.arbolMenuHistorico = [];
    this.currentFatherSinceNode = undefined;
    this.answerDisplayed = false;
    this.answerNode = undefined;
    this.answerDisplayed = false;
    this.loadArbolMenu(this.ctx.idMenu, this.ctx.idNodo);

  }

  returnToStart() {
    if (this.arbolMenuHistorico.length > 1) {
      this.ctx.idMenu = this.ctx.historialMenus[0];
      this.ctx.historialMenus = [this.ctx.idMenu];
      const currentHist = this.arbolMenuHistorico[0];
      if (currentHist && currentHist.arbol) {
        this.arbolMenu = currentHist.arbol;
      }
    }

    this.currentFatherNode = undefined;
    this.currentFatherOldMenu = undefined;
    this.temaCurrentFatherOldMenu = undefined;
    this.displayCurrentFatherOldMenu = false;

    this.menusNodos = [this.ctx.idMenu];

    this.currentFather = this.arbolMenu.root;
    this.currentGrandparent = undefined;

    this.reloadTree();
    this.clearAnswerDisplayed()
    this.loadFAQ()
    this.updateVisiblePath()
    this.miValorVariable = 'Raiz';
    this.miValorVariablePadre = '';

    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode) {
      this.displayButtonReturnNode = true;
    }
  }

  seleccionarNodo(event) {
    this.displayCurrentFatherOldMenu = false;

    this.displayButtonReturnNode = false;
    if (this.ctx.idNodo) {
      this.displayButtonReturnNode = true;
    }

    for (let nodo of this.displayedNodes) {
      if (nodo.id == event) {
        if (nodo.childs.length > 0) {
          this.currentFather = nodo;
          if (this.ctx.idNodo && this.ctx.idNodo == nodo.parentId) {
            this.currentGrandparent = this.currentFatherNode;
          }
          if (this.menusNodos && this.menusNodos.length > 0 && this.menusNodos[this.menusNodos.length - 1] != nodo.menuId) {
            this.displayCurrentFatherOldMenu = true;
          }

          if (!this.menusNodos.includes(nodo.menuId)) {
            this.menusNodos.push(nodo.menuId);
          }

          this.reloadTree();
          this.loadFAQ();
          this.updateVisiblePath();
          this.miValorVariable = this.currentFather.name;
          this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
        }
      }
    }

    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.currentFather.id) {
      this.displayButtonReturnNode = true;
    }
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async emitRenderMenuArbol(event) {
    this.cargandoDatos = true;
    this.displayCurrentFatherOldMenu = false;
    const idOldMenu = this.ctx.idMenu;
    this.renderMenuArbolEmitter.emit(event);
    await this.sleep(500);

    if (idOldMenu && idOldMenu != undefined && idOldMenu != this.ctx.idMenu) {
      if (this.currentFatherOldMenu) {
        this.temaCurrentFatherOldMenu = this.currentFatherOldMenu.name;
      } else {
        this.temaCurrentFatherOldMenu = this.currentFather.name;
      }
      this.currentFatherOldMenu = this.currentFather;
      this.displayCurrentFatherOldMenu = true;
      this.loadArbolMenu(this.ctx.idMenu, null);
      //this.menusNodos.push(this.ctx.idMenu);
    } else {
      this.cargandoDatos = false;
    }
  }


  loadFAQ() {
    this.currentFAQ = []
    for (let faq of this.currentFather.faqs) {
      let node = new NodoArbolMenu(
        undefined,
        undefined,
        undefined,
        faq.consulta,
        undefined,
        NodeType.FAQ,
        undefined,
        undefined,
        faq.respuesta,
        undefined,
        undefined,
        faq.codigoTemaDestinatario
      );
      this.currentFAQ.push(node);
    }

  }


  reloadTree() {
    if (this.currentFather.id === "ROOT") {
      this.currentFatherNode = this.currentFather;
    }
    if (this.currentGrandparent == undefined && this.currentFatherOldMenu != undefined && this.arbolMenuHistorico) {
      for (let hist of this.arbolMenuHistorico) {
        if (this.currentFatherOldMenu.menuId == hist.idMenu) {
          this.currentGrandparent = hist.currentNode;
        }
      }
    }
    this.displayedNodes = this.sortNodes(this.currentFather.childs).filter(n => n.visible);
    console.log(this.displayedNodes);
    this.displayForm = (this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario;
  }

  displayAnswer(obj) {
    this.answerNode = obj;
    this.displayForm = (this.answerNode.idDestinatario !== undefined);
    // this.generateHTMLLinks(this.answerNode.answer);
    this.answerDisplayed = true;
    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.answerNode.id) {
      this.displayButtonReturnNode = true;
    }
    this.miValorVariable = this.answerNode.name;
    this.miValorVariablePadre = this.currentFather.name !== "Raiz" ? this.currentFather.name : '';
  }

  clearAnswerDisplayedNode() {
    this.answerNode = undefined;
    this.answerDisplayed = false;
    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.currentFather.id) {
      this.displayButtonReturnNode = true;
    }
    //this.habilitado = true;
    //this.displayForm = this.currentFather &&  ((this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario);
  }



  clearAnswerDisplayed() {
    this.answerNode = undefined;
    this.answerDisplayed = false;
    this.displayCurrentFatherOldMenu = false;

    if (this.menusNodos && this.menusNodos.length > 1
      && ((this.menusNodos[this.menusNodos.length - 1] == this.currentFather.menuId)
        && (this.currentFather.name == 'Raiz' && this.currentFather.id == 'ROOT'))) {
      this.displayCurrentFatherOldMenu = true;
      this.menusNodos.pop();
    }

    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.currentFather.id) {
      this.displayButtonReturnNode = true;
    }
    //this.habilitado = true;
    //this.displayForm = this.currentFather &&  ((this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario);
    this.miValorVariable = this.currentFather.name;
    this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
  }

  sortNodes(nodes: NodoArbolMenu[]) {
    let sorted = nodes ? nodes.sort((a, b) => {
      return a.order - b.order;
    }) : [];
    return sorted;
  }

  cargarConsulta() {
    // Antes de cargar el formulario se guarda el historico de navegacion (desde donde partio la llamada al formulario)
    this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
    this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
    this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
    this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;

    if (this.answerNode && (this.answerNode.type === 'RESPUESTA' || this.answerNode.type === 'FAQ')) {
      //this.ctx.etiquetaTema = this.answerNode.name;
      this.ctx.etiquetaNodoArbol = this.answerNode.name;
      this.ctx.idNodo = this.answerNode.id;
  
      this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.answerNode, tipo:NodeType.Form })
      //this.renderMenuArbolEmitter.emit({idServicio: environment.formAsistencia, codigoTema:this.answerNode.areaCode});
      //this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.idFormAsociado, codigoTema: this.answerNode.areaCode, esEmail: true });
    } else {
      // Se asigna el nombre del nodo a la etiqueta par que despliegue el formulario de consulta
      //this.ctx.etiquetaTema = this.currentFather.name;
      this.ctx.codigoNodoArbol = this.currentFather.id;
      this.ctx.etiquetaNodoArbol = this.currentFather.name;

      //this.renderMenuArbolEmitter.emit({idServicio: environment.formAsistencia, codigoTema:this.currentFather.areaCode})
      this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.idFormAsociado, codigoTema: this.currentFather.areaCode, esEmail: true })
    }
  }

  loadParentOldMenu() {
    this.displayCurrentFatherOldMenu = false;
    //this.temaCurrentFatherOldMenu = '';
    let historico = [];
    let idMenuHist = [];
    for (let hist of this.arbolMenuHistorico) {
      if (this.ctx.idMenu != hist.idMenu) {
        if (!idMenuHist.includes(hist.idMenu)) {
          historico.push(hist);
          idMenuHist.push(hist.idMenu);
        }
      }
    }
    for (let hist of this.arbolMenuHistorico) {
      if (this.currentFatherOldMenu.menuId == hist.idMenu) {
        const beforeHist = this.arbolMenuHistorico.find(c => c.idMenu == this.ctx.obtenerMenuAnterior());
        if (beforeHist) {
          this.arbolMenu = beforeHist.arbol;
        } else {
          this.arbolMenu = hist.arbol;
        }
        const currentHist = this.arbolMenuHistorico.find(c => c.idMenu == this.ctx.obtenerMenuActual());
        if (currentHist && currentHist.oldNodoArbolMenu) {
          this.currentFather = currentHist.oldNodoArbolMenu;
        } else {
          this.currentFather = hist.currentNode;
        }


        //this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
        this.reloadTree();
        this.clearAnswerDisplayed();
        this.loadFAQ();
        this.updateVisiblePath();
        if (idMenuHist.length == 1) {
          this.ctx.idMenu = idMenuHist[0];
        } else {
          this.ctx.idMenu = hist.idMenu;
        }

        this.ctx.historialMenus = idMenuHist;
        this.arbolMenuHistorico = historico;
        this.displayCurrentFatherOldMenu = true;
        if (this.arbolMenuHistorico.length > 1) {
          this.currentFatherOldMenu = hist.currentNode;
          this.displayCurrentFatherOldMenu = true;
        } else {
          this.currentFatherOldMenu = undefined;
          this.displayCurrentFatherOldMenu = false;
        }
        break;
      }
    }
  }

  loadParent() {
    //Crear método en el árbol para hacer búsqueda.
    if (this.currentFatherNode && this.ctx.idNodo && this.ctx.idNodo == this.currentFather.parentId) {
      this.currentFather = this.currentFatherNode;
      this.currentGrandparent = this.currentFatherNode;
    } else {
      this.currentFather = this.arbolMenu.search(this.currentFather.parentId);
      this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
    }

    this.reloadTree();
    this.clearAnswerDisplayed();
    this.loadFAQ();
    this.updateVisiblePath();
    this.miValorVariable = this.currentFather.name;
    this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
  }

  //Slicing del path para que no quede muy largo
  updateVisiblePath() {
    if (this.currentFather.id === "ROOT") {
      return;
    }
    if (this.currentFather.path.length > this.maxPathLength) {
      let split = this.currentFather.path.split(">")
      let i = split.length - 1;
      let aux = "";
      while (i > 0) {
        if (aux.length + split[i].length > this.maxPathLength) {
          break;
        }
        if (i !== split.length - 1) {
          aux = split[i] + ">" + aux;
        }
        else { aux = split[i] }
        i--;
      }
      aux = aux === "" ? split[i] : aux;
      this.visiblePath = "... " + aux;
    }
    else {
      this.visiblePath = this.currentFather.path;
    }

  }

  updateGrandparent() {

  }


  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
  }

  ngOnDestroy(): void {
  }

  obtenerEtiquetaVolver() {  
    let etiqueta = "Volver a " + (this.currentFather ? this.currentFather.name : "Inicio");
    if (this.currentFather && this.currentFather.name == "Raiz") {
      etiqueta = "Volver";
    }
    return etiqueta;
  }
}
